import { RouteConfig } from "vue-router/types/router";

export const expertRatingsRoutes = (startTemplate: string): RouteConfig[] => [
    {
        path: startTemplate + '/expert-ratings',
        name: 'ExpertRatings',
        component: () => import(/* webpackChunkName: "expert-ratings" */ '../../views/ExpertRatingsView.vue')
    },
    {
        path: startTemplate + '/expert-ratings/:id/summary',
        name: 'RatingsSummary',
        component: () => import(/* webpackChunkName: "expert-ratings" */ '../../views/ExpertRatingsView.vue')
    },
    {
        path: startTemplate + '/expert-ratings/:id/:userProfileId?',
        name: 'ExpertRatingsPage',
        component: () => import(/* webpackChunkName: "expert-ratings" */ '../../views/ExpertRatingsView.vue')
    },
]
